import { render, staticRenderFns } from "./review-component-text.vue?vue&type=template&id=25fa62f0"
import script from "./review-component-text.vue?vue&type=script&lang=js"
export * from "./review-component-text.vue?vue&type=script&lang=js"
import style0 from "./review-component-text.vue?vue&type=style&index=0&id=25fa62f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports